import { useHistory } from 'react-router-dom';
import { Spin, Descriptions, Tag, Button } from 'antd';
import { GetWaterPumpById } from 'apollo/configuration';
import { I18n } from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faCopy } from '@fortawesome/free-solid-svg-icons';
import { WaterPumpStateButton } from '../components';

export function DetailWater({ _id, onCloseDrawer }) {
  const history = useHistory();
  const { data: dataWaterPumpById, isLoading, error } = GetWaterPumpById({ _id });

  if (_id && error) history.push('/error-server');

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(dataWaterPumpById.deviceId);
  };

  return (
    <>
      {isLoading ? (
        <Spin spinning={isLoading} />
      ) : (
        <Descriptions size="middle" column={1}>
          <Descriptions.Item label={`${I18n('name', true)}`}>
            {dataWaterPumpById?.name}
          </Descriptions.Item>
          <Descriptions.Item label={`${I18n('location', true)}`}>
            {dataWaterPumpById?.location}
          </Descriptions.Item>
          <Descriptions.Item className="rk-descriptions-items" label={`${I18n('code', true)}`}>
            {dataWaterPumpById?.deviceId}
            <Button
              style={{ marginLeft: 'auto' }}
              icon={<FontAwesomeIcon icon={faCopy} />}
              size="large"
              onClick={handleCopyClick}
            />
          </Descriptions.Item>
          <Descriptions.Item label={`${I18n('state', true)}`}>
            {dataWaterPumpById?.active ? (
              <Tag icon={<FontAwesomeIcon icon={faCheck} />} color={'success'}>
                {`  ${I18n('activate')}`}
              </Tag>
            ) : (
              <Tag icon={<FontAwesomeIcon icon={faTimes} />} color={'error'}>
                {`  ${I18n('inactive')}`}
              </Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label={`${I18n('device', true)}`}>
            {dataWaterPumpById?.device.name}
          </Descriptions.Item>
        </Descriptions>
      )}
      <div className="rk-button-group">
        <WaterPumpStateButton
          active={dataWaterPumpById.active}
          _id={dataWaterPumpById._id}
          onCloseDrawer={(e) => onCloseDrawer(e)}
        />
      </div>
    </>
  );
}
